import axios from 'axios';
import { IGizmo, IRealmFormGizmo, IUserV2 } from '../../types';
import { rootGizmoConfigV2ToV3 } from '../../gizmos/utils';
import { IDatabase } from '../../database';

interface IParams {
  fid: string;
  publicRG?: boolean;
  context: {
    apiUrl: string;
    user?: IUserV2;
    database?: IDatabase;
  };
}

/**
 * Get root gizmo configurations from the server
 *
 * @param {string} fid Flowy id of the root gizmo
 *
 * @returns {IGizmo[]} array of root gizmo configurations from the server
 */
function getRootGizmoConfigs({
  fid,
  publicRG,
  context,
}: IParams): Promise<IGizmo[]> {
  return new Promise<IGizmo[]>(async resolve => {
    const { apiUrl, database, user } = context;
    let rootGizmoConfigs: IGizmo[] = [];
    let url: string | undefined;
    let headers = {};

    if (user?.credentials) {
      const credentials: any = user.credentials;
      url = `${apiUrl}/main_api/v1/root_gizmo/${fid}`;
      if (publicRG) {
        url = `${apiUrl}/main_api/v1/public/root_gizmo/${fid}`;
      }
      headers = {
        ...credentials,
      };
    } else if (publicRG) {
      url = `${apiUrl}/main_api/v1/public/root_gizmo/${fid}`;
    }

    if (url) {
      try {
        if (fid === '63f5234b4732de0015a3202a') {
          // url = 'https://aws-react-front-87.s3.us-east-2.amazonaws.com/config.json'
          // url = 'https://aws-react-front-87.s3.us-east-2.amazonaws.com/config_local_1.json'
          // url = 'https://aws-react-front-87.s3.us-east-2.amazonaws.com/config_5.json'
        } else if (fid === '642339b991693305f886305d') {
          // url = 'https://aws-react-front-87.s3.us-east-2.amazonaws.com/delivery_v1.json';
          // url = 'https://aws-react-front-87.s3.us-east-2.amazonaws.com/delivery_v2.json';
        } else if (fid === '645bd0e9be3d3b001d6bf817') {
          // url = 'https://aws-react-front-87.s3.us-east-2.amazonaws.com/cuis_artesanas.json';
        }

        // try {
        //   const savedForm: IRealmFormGizmo | undefined = await database?.get({
        //     type: 'forms',
        //     fid,
        //   });
        //   // console.log('sssssssssssssssssssssssssssssssF: ', savedForm);

        //   if (savedForm) {
        //     rootGizmoConfigs = rootGizmoConfigs.concat([
        //       rootGizmoConfigV2ToV3({ config: savedForm.formGizmo }),
        //     ]);
        //     return resolve(rootGizmoConfigs);
        //   }
        // } catch (e) {
        //   console.log('*-*-*-*-*-*-*-*e: ', e);
        // }

        const rootGizmoConfigsResponse = await axios.get(url, {
          headers,
        });

        if (rootGizmoConfigsResponse.status === 200) {
          const { forms } = rootGizmoConfigsResponse.data;

          console.log('++++++++++++++++++++++++++++forms: ', forms);

          if (forms && Array.isArray(forms) && forms.length > 0) {
            if (database) {
              for (const form of forms) {
                console.log('dddddddb.set->form: ', form);
                await database.set({
                  type: 'forms',
                  value: form,
                  update: true,
                });
              }
            }

            rootGizmoConfigs = rootGizmoConfigs.concat(
              forms.map(f => rootGizmoConfigV2ToV3({ config: f }))
            );
          }
        }
      } catch (e) {
        console.log('<><><><>getRootGizmoConfigs->e: ', e);
      }
    }

    resolve(rootGizmoConfigs);
  });
}

export default getRootGizmoConfigs;
